import Vue from 'vue';
import tvbetService from '../services/tvbet.service';

const handlers = {
    tvbet: {
        session: {
            set: 'tvbet_session_set'
        },
        topEvents: {
            set: 'tvbet_topEvents_set'
        }
    }
};

const initVuexState = function(state) {
    state.tvbet = {
        session: null
    };
};

const initGetters = function(getters) {
    getters.tvbet = state => state.tvbet;
};

const initActions = function(actions) {
    actions[handlers.tvbet.session.set] = ({ commit }, session) => commit(handlers.tvbet.session.set, session);
};

const initMutations = function(mutations) {
    mutations[handlers.tvbet.session.set] = (state, session) => (state.tvbet.session = session);
};

const initAppState = function(appState, store) {
    appState.tvbet = {
        session: {
            get: () => store.getters.tvbet.session,
            open: async () => {
                let session = await tvbetService.openSession();
                store.dispatch(handlers.tvbet.session.set, session);
            },
            openDemo: async () => {
                let session = await tvbetService.openDemoSession();
                store.dispatch(handlers.tvbet.session.set, session);
            },
            close: async () => {
                if (store.getters.tvbet.session) {
                    await tvbetService.closeSession();
                }
                store.dispatch(handlers.tvbet.session.set, null);
            }
        }
    };
};

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};



// WEBPACK FOOTER //
// ./_common/data/tvbet.js